import { render } from "./supplier-detail.vue?vue&type=template&id=417ad7e4"
import script from "./supplier-detail.vue?vue&type=script&lang=js"
export * from "./supplier-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__